// we don't want to import any repo packages here

import { isObjectLike, isString } from '../../src/lib/typeInference.js';

export interface ObjectIdLike {
    toHexString(): string;
}

export function isObjectIdString(x: any): x is string {
    // Test if an input string is a valid ObjectId in string format
    const pattern = /^(?=[a-f\d]{24}$)(\d+[a-f]|[a-f]+\d)/i;

    return isString(x) && pattern.test(x);
}

export function isObjectIdLike(x: unknown): x is ObjectIdLike {
    return isObjectLike(x) && 'toHexString' in x && typeof x.toHexString === 'function';
}

export type ObjectIdOrString = ObjectIdLike | string;

export function isObjectIdOrString(x: unknown): x is ObjectIdOrString {
    return typeof x === 'string' || isObjectIdLike(x);
}

export interface IPagedCollection<T> {
    items: T[];
    page: {
        count?: number;
        limit: number;
        startKey?: string;
        nextKey?: string;
    };
}

export interface IPageRequest {
    limit: number;
    startKey?: string;
}

// This does not support nested paths.  Use (for example) sort['when.timestamp'] = 1
export type Sort<Entity> =
    | {
          [P in keyof Entity]?: 1 | -1;
      }
    | { [key: string]: 1 | -1 };

export enum SortOrder {
    ASC = 1,
    DESC = -1
}
